import {Request as BaseRequest} from "brigada/src/class/Request.js";
import {BodyMode} from "base/assets/js/widget/BodyMode.js";
import {Sb} from "base/assets/js/widget/Sb.js";
import {Layers} from "base/assets/js/widget/Layers.js";

export class Request extends BaseRequest {

	optsMap() {
		let oMap = super.optsMap();
		oMap[ 'data-old' ] = 'b:bOld';
		return oMap;
	}

	urlBlank( oOpts ) {
		if( oOpts.bOld ) {
			const oLayers = this.newRelQuery().typeOf( Layers ).find();
			if( oLayers ) {
					oLayers.message(
						`<p class="t-p">К сожалению, запрошенная страница еще в разработке :(</p>
						<p class="t-p"><a class="t-a" href="${oOpts.sUrl}" target="_blank">Перейти на страницу в прежней версии сайта</a></p>`

					);
			}
			return false;
		}
		return super.urlBlank( oOpts );
	}

	/*frame( oOpts ) {

		const bRet = super.frame( oOpts );
		if( !bRet ) {


		}
		return bRet;
	}*/

	/**
	 * @return {BodyMode}
	 */
	/*_getBodyMode() {
		if( !this._oBodyMode ) {
			this._oBodyMode = this.newRelQuery()
				.typeOf( BodyMode )
				.find();
		}
		return this._oBodyMode;
	}*/
}